
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('kpiDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <template  v-if="this.dependentEvaluations.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteKeyPerformanceIndicator') }}</label>
                        <div v-for="(evaluation, i) in this.dependentEvaluations" :key="i">
                            {{ evaluation.name }}<br/>
                        </div>
                    </template>
                    <p v-else>{{ $t('wannaDeleteThisKeyPerformanceIndicator') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteKeyPerformanceIndicator" :disabled="this.dependentEvaluations.length > 0">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import evaluationApi from "../../api/server/evaluation";
import KeyPerformanceIndicatorApi from "../../api/server/kpi";

export default {
    name: "kpiDeleteModal",
    mounted() {
        this.requestDependencies();
    },
    methods: {
        async requestDependencies() {
            this.dependentEvaluations = await evaluationApi.evaluationListByKpi(this.$parent.$route.params.id, this.$parent.keyPerformanceIndicatorToDeleteId);
        },
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteKeyPerformanceIndicator() {
            await KeyPerformanceIndicatorApi.kpiDelete(this.$parent.$route.params.id, this.$parent.keyPerformanceIndicatorToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    },
     data() {
        return {
            dependentEvaluations: [],
        }
    }
};
</script>